import React, { useState } from 'react'
import Title from 'antd/es/typography/Title'
import { Button, Space } from 'antd'
import { StarFilled, StarOutlined } from '@ant-design/icons'
import { warningColor } from '../../../../constants/styles'
import { useDispatch, useSelector } from 'react-redux'
import { actions } from '../../../../store/reducers/assignment.reducer'
import { useParams } from 'react-router'
import { useAssignmentAccess } from '../access/Access'
import { AssignmentPermissions } from '../../../../constants/assignment-permissions'

const FileDrawerHeader = () => {
    const drawer = useSelector(state => state.assignment.drawer)
    const dispatch = useDispatch()

    const { token, layerId } = useParams()
    const hasEditingPermission = useAssignmentAccess([AssignmentPermissions.CAN_EDIT])

    const [isWaitingForUpdateArchetype, setIsWaitingForUpdateArchetype] = useState(false)

    const handleArchetypeClick = async () => {
        setIsWaitingForUpdateArchetype(true)
        await dispatch(actions.updateFileArchetype(token, layerId, drawer.file.id, !drawer.file.is_archetype))
        setIsWaitingForUpdateArchetype(false)
    }

    return (
        <Space size='middle'>
            <Title level={3} style={{ margin: 0, fontSize: '1rem' }}>
                {drawer?.file?.name}
            </Title>
            <Button
                shape='circle'
                type='text'
                icon={
                    drawer?.file.is_archetype ? (
                        <StarFilled style={{ color: warningColor }} />
                    ) : (
                        <StarOutlined style={{ color: warningColor }} />
                    )
                }
                title={drawer?.file.is_archetype ? 'Remove from archetypes' : 'Add to archetypes'}
                onClick={handleArchetypeClick}
                loading={isWaitingForUpdateArchetype}
                disabled={!hasEditingPermission}
            />
        </Space>
    )
}

export default FileDrawerHeader
